export default __webpack_public_path__ + "static/B0127-2471ff5ed3c9daaa53df7168fa37b601.png";